import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudForm from "../../components/dashboard/form/CrudForm";
import productService from "../../services/productService";
import Swal from "sweetalert2";
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function CreateAdvertisement() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const res = await productService.getAllProducts();
      const productsArray = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];
      setProducts(productsArray);
    } catch (err) {
      console.error(err);
    }
  };

 const handleSubmit = async (formData) => {
  try {
    const status = Number(formData.status);

  await Promise.all(
  formData.products.map((product) =>
    productService.updateAdvertised(product.id, {
      is_advertised: status,
      price: formData.price,
      offer_price: formData.offer_price,
      offer_start_date: formData.offer_start_date,
      offer_end_date: formData.offer_end_date,
    })
  )
);
    Swal.fire({
      title: "Success",
      text: "Advertisement updated successfully!",
      icon: "success",
      confirmButtonText: "OK",
      customClass: {
        confirmButton: "swal-confirm-btn",
      },
    });

    navigate("/admin/advertise-section-products");
  } catch (err) {
    Swal.fire("Error!", err.message || "Something went wrong", "error");
  }
};

 return (
  <DashboardWrapper>
    <div className="container mt-4">
   <Breadcrumb/>

      <div className="card shadow-sm">
        <div className="card-body">
          {/* <h4 className="card-title mb-4">Create Advertisement</h4> */}

          <CrudForm
           initialData={{
 
  price: "",
  offer_price: "",
  offer_start_date: "",
  offer_end_date: "",
   status: 1,
  products: [],
}}

            onSubmit={handleSubmit}
        allowedFields={[
 
  "price",
  "offer_price",
  "offer_start_date",
  "offer_end_date",
   "status",
  "products",    
]}

       customFields={{
  products: { type: "multi-select" },

  status: {
    label: "Is Advertised",
    type: "select",
    options: [
      { value: 1, label: "Yes" },
      { value: 0, label: "No" },
    ],
  },

  price: {
    label: "Price",
    type: "number",
  },

  offer_price: {
    label: "Offer Price",
    type: "number",
  },

  offer_start_date: {
    label: "Offer Start Date",
    type: "date",
  },

  offer_end_date: {
    label: "Offer End Date",
    type: "date",
  },
}}

            products={products}
          />
        </div>
      </div>
    </div>
  </DashboardWrapper>
);
}